import React from "react";
import IOText from "../ReUableComponents/ImageOntext";
import CBanner from "../Assessts/Images/CBanner.png";
import "../Assessts/Styles/ContactUs.scss";
import { IoLogoWhatsapp } from "react-icons/io";
const ContactUs = () => {
      const contactData = [
        {
            title: "Technical Related Queries",
            name: "NSF Technical Support Team",
            phone: "+91 7416837565",
            email: "indiascholarships@northsouth.org",
        },
        {
            title: "Scholarship Application Related Queries",
            name: "Ms. Mamatha Raavi",
            phone: "+91 7416837565",
            email: "mamatha.raavi@northsouth.org",
        },
        {
            title: "Payment/Disbursement Related Queries",
            name: "Mr. Chinna Rao Menda",
            phone: "+91 8328524509",
            email: "chinna.menda@northsouth.org",
        },
        {
            title: "Seva (Community Service) Related Queries",
            name: "Ms. Sangeetha R",
            phone: "+91 9494011166",
            email: "ratlavath.sangeetha@northsouth.org",
        },
        {
            title: "Mentorship Related Queries",
            name: "Ms. Sravanthi Dhannapaneni",
            phone: "+91 9966460306",
            email: "sravanthi.dhannapaneni@northsouth.org",
        },
        {
            title: "Skill Development Related Queries",
            name: "Mr. Manoj Kumar D",
            phone: "+91 9505010227",
            email: "manoj.dharamalla@northsouth.org",
        },
    ];
    return (
        <>
            <div className="Single_Banner mt-2">
                <IOText Image={CBanner} Alt="EMpower" Text={<div className="Text-MainDiv w-100" >
                    <div ><span style={{ color: "#F7D670" }}>Connect With Us </span>for <span style={{ color: "#F7D670" }}>Scholarship-Related Assistance</span> and Information.</div>
                </div>} />
            </div>
            <div className="Web-MainHeading mt-3">Contact Us – Customer Assistance</div>

            {/* <div className="dflex gap-3 JCCenter ContactUs-Details mb-4">
                <div className="dflex gap-3  flexd-column">
                    <span className="dflex ">
                        <p>Active working hours - 10:00 AM - 5:30 PM  (Monday to Friday)</p>
                        <p><IoLogoWhatsapp /> 9494011166</p>
                    </span>
                    <span className="Web-SubHeading">indiascholarships@northsouth.org</span>
                </div> */}

            {/* </div> */}

            <section className="contact-section mb-3">
                <div className="working-hours pt-3">
                    Active working hours - 10:00 AM - 5:30 PM (Monday to Friday)
                </div>
                <div className="contact-grid pb-2">
                    {contactData.map((contact, index) => (
                        <div className="contact-card" key={index}>
                            <h2>{contact.title}</h2>
                            <p className="contact-name">{contact.name}</p>
                            <p> Cell: {contact.phone} <span>(WhatsApp Only)</span> </p>
                            <p>
                                E-Mail:
                                <a href={`mailto:${contact.email}`}>
                                    {contact.email}
                                </a>
                            </p>
                        </div>
                    ))}
                </div>
            </section>
        </>
    )
}
export default ContactUs;